import { render, staticRenderFns } from "./BalanceMoveCard.vue?vue&type=template&id=1c703941&"
import script from "./BalanceMoveCard.vue?vue&type=script&lang=ts&"
export * from "./BalanceMoveCard.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceMoveCard.vue?vue&type=style&index=0&id=1c703941&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports